import React, {useState } from "react";
import { MapContainer, TileLayer, Polygon, Marker, Popup } from "react-leaflet";
import marker from "../../images/marker.png";
import L from "leaflet";
import { useNavigate } from "react-router-dom";
import AllLocalityDropdown from "./AllLocalityDropdown";
import UrltoSlug from "./UrlToSlug";

const AllLocalitiesMap = ({
  allLocalities,
  category,
  commercialServiceQuery = "",
  property_type,
}) => {
  const navigate = useNavigate();
  const [lonLat, setLonLat] = useState([26.9163, 75.7884]);
  const [areaCoords, setAreaCoords] = useState([]);
  // Custom marker icon
  const customIcon = new L.Icon({
    iconUrl: marker,
    iconSize: [32, 35],
    iconAnchor: [8, 32],
    popupAnchor: [0, -32],
  });

  const handleNavigate = (locality) => {
    const title = {
      buy: "apartments-for-sale-in-",
      rent: "apartments-for-rent-in-",
      plot: "plots-for-sale-in-",
      commercial: "offices-for-sale-in-",
      living: "pg-in-",
    };

    const finalCategory = category === "plot" ? "buy" : category;
    const type =
      category === "commercial"
        ? commercialServiceQuery
        : category === "living"
        ? "living"
        : "";
    const filter = localStorage.setItem(
      "feature_clicked",
      `property_type:${property_type}`
    );

    const text1 = `${finalCategory}/${
      finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
    }searches`;
    const text2 = `${locality?.property_location}-srlid-${locality?.locality_id}`;
    const extra = title[category];
    const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
    navigate(`/${url}`, {
      state: { name: "city", service: category, type: type, filter: filter },
    });
  };

  const handleLatLon = (lat, lon, coordinatesString) => {
    setLonLat([lat, lon]);
    let formattedCoords = [];
    if (coordinatesString) {
      formattedCoords = coordinatesString
        .match(/\[([^\]]+)\]/g) // Extract each coordinate pair
        .map((coord) => coord.replace(/[\[\]]/g, "")) // Remove brackets
        .map((coord) => coord.split(",").map(Number)); // Convert to number array
    }
    setAreaCoords(formattedCoords);
  };

  return (
    <>
      <section className=" location-section sectiontopgap">
        <div className="container">
          <div className="sectiontitle">
            <div className="titleunderline" data-aos="fade-right">
              <svg
                className="desk"
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
              <svg
                className="mob"
                style={{ margin: "20px auto 0px auto" }}
                width="64"
                height="2"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#000"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <h1>Explore Top Localities in Jaipur</h1>
          </div>
          <div className="desk-hide">
            <AllLocalityDropdown
              subLocalities={allLocalities}
              category={category}
              commercialServiceQuery={commercialServiceQuery}
              property_type={property_type}
            />
          </div>

          <div className="content content_margin mob-hide ">
            <div className="localityBox">
              <div className="locName">
                {allLocalities?.length > 0 &&
                  allLocalities.map((locality, index) => (
                    <div className="tick-and-name" key={index}>
                      <svg
                        width="23"
                        height="22"
                        viewBox="0 0 23 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.17969 11.0004L9.80135 13.5946L15.0539 8.40625"
                          stroke="#343434"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span
                        className="place-name"
                        onClick={() =>
                          handleLatLon(
                            locality.latitude,
                            locality.longitude,
                            locality.coordinates
                          )
                        }
                      >
                        {locality?.locality_name}
                      </span>
                      <div className="dotted-border"></div>
                      <div
                        onClick={() =>
                          handleLatLon(
                            locality.latitude,
                            locality.longitude,
                            locality.coordinates
                          )
                        }
                      >
                        {locality?.count}
                      </div>
                      <div
                        onClick={() => handleNavigate(locality)}
                        className="link-icon"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="9" cy="9" r="9" fill="#F78834" />
                          <path
                            d="M9.11765 8.88237L12.9412 5.05884"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.7188 4.23242L13.9102 6.33901"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.7189 4.23253L11.6123 4.04102"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.63 9.31501V11.904C12.63 12.8572 11.8573 13.63 10.904 13.63H5.726C4.77276 13.63 4 12.8572 4 11.904V6.726C4 5.77276 4.77276 5 5.726 5H8.31499"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  ))}
              </div>

              <div className="locMap">
                <MapContainer
                  center={lonLat}
                  zoom={12}
                  style={{ height: "330px", width: "100%" }}
                  key={lonLat.toString()}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />

                  {/* Render the dummy polygon */}
                  {areaCoords && (
                    <Polygon
                      positions={areaCoords}
                      pathOptions={{
                        color: "#5b74d8",
                        fillColor: "#5b74d880",
                        fillOpacity: 0.5,
                      }}
                    />
                  )}

                  {/* Marker with Popup */}
                  <Marker position={lonLat} icon={customIcon}>
                    <Popup>
                      <span>
                        Location: {lonLat[0]}, {lonLat[1]}
                      </span>
                    </Popup>
                  </Marker>
                </MapContainer>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllLocalitiesMap;
